module.exports = __webpack_public_path__ + "media/5_5.17bac7f7.wav";